"use client";

import EditIcon from "@mui/icons-material/Edit";
import { Menu } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

import ROUTE_URLS from "@/constants/route-urls";
import useLanguage from "@/contexts/language-context";
import { ICustomerTemplate } from "@/interfaces/customer-template.interface";
import { MessageTemplateMessages } from "@/messages/message-template/message-template.messages";
import NotificationItem from "@/mui/Items/NotificationItem";

type Props = {
  isOpen: boolean;
  anchorEl: (EventTarget & HTMLButtonElement) | null;
  onClose: () => void;
  messages: MessageTemplateMessages;
  selectedTemplate: ICustomerTemplate;
};

export function MessageTemplatePopover({
  isOpen,
  anchorEl,
  onClose,
  messages,
  selectedTemplate,
}: Props) {
  const router = useNavigate();
  const { lang } = useLanguage();

  return (
    <Menu
      open={isOpen}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
    >
      <NotificationItem
        icon={<EditIcon />}
        onClick={() => router(ROUTE_URLS.updateMessageTemplate(lang, selectedTemplate.id))}
        title={messages.editButton}
      />
    </Menu>
  );
}
